import React, { FC } from 'react';

import { ExpandTable } from '@eika/expand-table';

import { Content } from '../../components/shared/Content';
import { ErrorCardWrapper } from '../../components/shared/ErrorCardWrapper';
import useLoanRepaymentPlan from '../../fetchHooks/useLoanRepaymentPlan';
import useAccountId from '../../hooks/queryparams/useAccountId';
import useTranslation from '../../hooks/useTranslation';
import formatLoanRepaymentPlan from '../../utils/mapper/formatLoanRepaymentPlan';
import LoanRepaymentPlanSkeleton from './LoanRepaymentPlanSkeleton';

import './LoanRepaymentPlan.scss';

const LoanRepaymentPlan: FC = () => {
    const translated = useTranslation();
    const accountId = useAccountId();
    const loanRepaymentPlan = useLoanRepaymentPlan(accountId);

    if (loanRepaymentPlan.isLoading) {
        return <LoanRepaymentPlanSkeleton />;
    }

    if (loanRepaymentPlan.error) {
        return (
            <Content>
                <ErrorCardWrapper
                    title={translated.errors.somethingWentWrong}
                    exception={loanRepaymentPlan.error}
                    defaultError={translated.loanRepaymentPlan.error}
                />
            </Content>
        );
    }

    if (!loanRepaymentPlan.data) {
        return null;
    }

    return (
        <ExpandTable
            id="loan-repayment-plan"
            tableRows={formatLoanRepaymentPlan(loanRepaymentPlan.data)}
            tableHeader={[
                {
                    id: '1',
                    label: translated.loanRepaymentPlan.period,
                },
                {
                    id: '2',
                    label: translated.loanRepaymentPlan.youPay,
                    boldColumn: true,
                },
                {
                    id: '3',
                    label: translated.loanRepaymentPlan.instalment,
                },
                {
                    id: '4',
                    label: translated.loanRepaymentPlan.interest,
                },
                {
                    id: '5',
                    label: translated.loanRepaymentPlan.charges,
                },
                {
                    id: '6',
                    label: translated.loanRepaymentPlan.balance,
                },
            ]}
        />
    );
};

export default LoanRepaymentPlan;
